// extracted by mini-css-extract-plugin
export default {"container":"YnuxyEsxEM5KocayMY9I","left":"RlTHp2PUW6ZvH6NWhRbm","right":"FwYzJhYNUSp_IPJoVkom","transparent":"pjRG7IsUrmyVfkozWwbK","icon":"xHC_W4L0lWuJgMsyRPuT"};